module.exports = __webpack_public_path__ + "img/yellow_noname.859bcdf8.svg";